// src/services/api.js
import axios from 'axios';

const API_URL = 'https://urqr.urqr.pro/api';
// const API_URL = 'https://qrkey.qrkey.info/api';
// const API_URL = 'http://127.0.0.1:8000/api';

export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, { email, password });
    return response.data;
  } catch (error) {
    console.error("Login error", error);
    throw error;
  }
};

export const register = async (name, email, password, phone, countryCode) => {
    try {
      const response = await axios.post(`${API_URL}/register`, { name, email, password, phone, countryCode });
      return response.data;
    } catch (error) {
      console.error("Login error", error);
      throw error;
    }
};

export const getGroupUsers = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/users/get-group-users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateContentPage = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();

    formData.append('id', payload.id);
    formData.append('title', payload.title);
    formData.append('email', payload.email);
    formData.append('subject', payload.subject);
    formData.append('identifier', payload.identifier);
    formData.append('keyStatus', payload.keyStatus);

    // Only append image if a new one is selected
    if (payload.imageFile) {
      formData.append('image', payload.imageFile);
    }

    const response = await fetch(`${API_URL}/users/update-qrcode`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        // Don't set Content-Type when using FormData; the browser handles it
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to update QR code');
    }

    return await response.json();
  } catch (error) {
    console.error("Update error:", error);
    throw error;
  }
};

export const sendMessage = async (name, email, message, slug) => {
  try {
    const response = await axios.post(`${API_URL}/submit-contact-form`, { name, email, message, slug });
    return response.data;
  } catch (error) {
    console.error("Login error", error);
    throw error;
  }
};

export const updatePassword = async (oldPassword, newPassword, confirmPassword) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${API_URL}/users/update-password`, 
      { oldPassword,newPassword,confirmPassword },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Login error", error);
    throw error;
  }
};

export const dashboardAPI = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ProfileAPI = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/users/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQRCoder = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/users/get-created-qr`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createContentPage = async (title, email, subject, identifier = null, label, number, keyStatus, imageFile) => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append("title", title);
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("identifier", identifier);
    formData.append("label", label);
    formData.append("number", number);
    formData.append("keyStatus", keyStatus);
    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await axios.post(
      `${API_URL}/users/create-content-page`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Create error", error);
    throw error;
  }
};


export const paymentStatus = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/users/payment-status`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkIdentifier = async ({identifier,title}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/users/check-identifier`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { identifier , title},
    });
    return response.data.exists;
  } catch (error) {
    console.error('Error checking identifier:', error);
    throw error;
  }
};
